.spinnerWrapper {
  box-sizing: border-box;
}

.spinnerWrapper *,
.spinnerWrapper *:before,
.spinnerWrapper *:after {
  box-sizing: inherit;
  width: 100%;
}

.spinner {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.spinner .viewBox {
  animation: rotate 1s linear infinite;
  display: block;
}

.spinner .circle {
  stroke-linecap: round;
  animation: dash 2s ease-in-out infinite;
  position: absolute;
}

.spinner .spinnerText {
  position: absolute;
  width: 100%;
  text-align: center;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 150;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -141;
  }
}
